export default "__VITE_ASSET__BogXPkCi__"